import React from 'react';

import { UncontrolledTooltip } from 'reactstrap';

function Paragrafo ({ title, id, text }) {
  return (
    <p
      id={id}
      style={{
        fontSize: '14px',
        marginBottom: '0px',
        display: `${text ? 'block' : 'none'}`
      }}
    >
      <strong>{title}: </strong>
      {text && text.slice(0, 25)}
      {text && text.length > 25 && '...'}
      {text && text.length > 25 && (
        <UncontrolledTooltip placement='top' target={id}>
          {text}
        </UncontrolledTooltip>
      )}
    </p>
  );
}

export default Paragrafo;



// WEBPACK FOOTER //
// ./src/pages/histologia/inclusao/Card/Paragrafo/index.js